import { BlindTestState } from './types';

export const blindTestInitialState: BlindTestState = {
  blindTest: null,
};
